import store from '@/store'
import Bus from '@/assets/js/vueBus'
import router from '@/router'
// import { delSlotPrefix } from "@/assets/js/utils";
import socket from '@/assets/js/websocket'
let ws
// 监听移除socket的事件，把版本改为-1,可以保证其他用户进来会刷新

// Bus.$on('removeSocket', () => {
//   version = -1
// })

const callback = {
  80400012: () => {
    // vm shout down
    Bus.$emit('removeSocket')
    Bus.$emit('singular-unbind')
  },
  80400013: () => {
    Bus.$emit('removeSocket')
  },
  81000001: () => {
    store.dispatch('actionSession', '')
    router.push({
      name: 'home',
      params: {
        message: 'logout'
      }
    })
  }
}

function message (event) {
  Bus.$emit('other-login', event)
}
const options = {
  callback, // error code callback
  message
}

function createWS (url) {
  ws = socket(url, options)
  return ws
}
export default createWS
